import { Box, MenuItem, Select, Typography } from "@mui/material";
import useColors from "../../../api/hooks/useColors";

const RoleSelection = ({
  selection,
  placeholder,
  setSelection,
  selectionList,
}) => {
  const colors = useColors();
  return (
    <>
      <Select
        value={selection || ""}
        displayEmpty
        onChange={(event) => setSelection(event.target.value)}
        disableUnderline
        sx={{
          "& .MuiInput-input": {
            borderBottom: `2px solid ${colors.grey_32percent}`,
          },
          "& .MuiSelect-select": {
            color: selection ? "inherit" : colors.gray_soft,
            fontSize: selection ? "inherit" : "12px",
            marginTop: selection ? 0 : "3px",
          },
        }}
        renderValue={(selected) => {
          if (!selected) {
            return (
              <Typography sx={{ color: colors.gray_soft, fontSize: "12px" }}>
                {placeholder}
              </Typography>
            );
          }
          return (
            <Box display="flex" gap={1}>
              <Typography variant="caption" sx={{ marginTop: "3px" }}>
                {selected}
              </Typography>
            </Box>
          );
        }}
      >
        {selectionList.map((type) => (
          <MenuItem key={type} value={type}>
            <Box display="flex" gap={1}>
              <Typography variant="caption">{type}</Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default RoleSelection;
